import { createCollectionReducer } from 'reducers/account/collections';
import { TYPE } from './actions';

export default createCollectionReducer(TYPE);

export const selectGroups = state => state[TYPE]?.profiles;
